import Chart from 'react-apexcharts';
import { ErrorBoundary } from 'react-error-boundary';
import { install } from 'resize-observer';
import type { ApexOptions } from 'apexcharts';
import type { IChargingGraphProps } from 'models/charging';

if (!window.ResizeObserver) {
    install();
}

const myErrorHandler = (error: Error) => {
    console.log(error);
};

const ChargingGraph = (props: IChargingGraphProps) => {
    const { graphData } = props;

    const options = {
        tooltip: {
            enabled: false,
        },
        chart: {
            id: 'area-datetime',
            type: 'area',
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
        },
        xaxis: {
            tickAmount: graphData.length > 0 ? graphData[graphData.length - 1][0] / 60 : 0,
            labels: {
                formatter: (value) => Math.floor(value / 60).toString(),
            },
        },
        annotations: {
            yaxis: [
                {
                    borderColor: '#999',
                    opposite: true,
                    type: 'numeric',
                    label: {
                        show: true,
                        text: 'mins',
                        offsetY: 45,
                        style: {
                            align: 'right',
                            color: '#fff',
                            background: '#2cae1e',
                        },
                    },
                },
            ],
            xaxis: [
                {
                    borderColor: '#999',
                    yAxisIndex: 0,
                    label: {
                        show: true,
                        text: 'Energy (kWh)',
                        offsetX: -45,
                        offsetY: -15,
                        style: {
                            color: '#fff',
                            background: '#2cae1e',
                        },
                    },
                },
            ],
        },
        dataLabels: {
            enabled: false,
        },
        markers: {
            show: false,
            size: 0,
            style: 'hollow',
        },

        fill: {
            type: 'gradient',
            gradient: {
                stops: [0, 100],
            },
        },
        stroke: {
            curve: 'straight',
        },
        colors: ['#d73a1f'],
    };
    const series = [
        {
            data: graphData,
        },
    ];
    return (
        <ErrorBoundary FallbackComponent={() => <></>} onError={myErrorHandler}>
            <div id="chart">
                <div id="chart-timeline">
                    <Chart
                        options={options as ApexOptions}
                        series={series}
                        type="area"
                        height={window.innerHeight * 0.4}
                    />
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default ChargingGraph;
